import { FeatureLimitsKeys } from '@/types'

type InternalApp = {
  type: 'internal'
  appSlug: string
  appName: string
  featureLimitKey: FeatureLimitsKeys
}

export const INTERNAL_APPS: Array<InternalApp> = [
  {
    type: 'internal',
    appSlug: 'tasks',
    appName: 'Task-Manager',
    featureLimitKey: FeatureLimitsKeys.AppTaskManager,
  },
  {
    type: 'internal',
    appSlug: 'clipboard',
    appName: 'Clipboard History',
    featureLimitKey: FeatureLimitsKeys.AppClipboardHistory,
  },
  {
    type: 'internal',
    appSlug: 'trashcan',
    appName: 'Trash Bin',
    featureLimitKey: FeatureLimitsKeys.AppTrash,
  },
  {
    type: 'internal',
    appSlug: 'autosave',
    appName: 'Autosave',
    featureLimitKey: FeatureLimitsKeys.AppAutoSave,
  },
  {
    type: 'internal',
    appSlug: 'colorpicker',
    appName: 'Colorpicker',
    featureLimitKey: FeatureLimitsKeys.AppColorPicker,
  },
  {
    type: 'internal',
    appSlug: 'locking',
    appName: 'Content Locking',
    featureLimitKey: FeatureLimitsKeys.AppContentLocking,
  },
  {
    type: 'internal',
    appSlug: 'advanced-paths',
    appName: 'Advanced paths',
    featureLimitKey: FeatureLimitsKeys.AppAdvancedPaths,
  },
  {
    type: 'internal',
    appSlug: 'token_permissions',
    appName: 'Access Token Scopes',
    featureLimitKey: FeatureLimitsKeys.AppAccessTokenScope,
  },
  {
    type: 'internal',
    appSlug: 'export',
    appName: 'Export',
    featureLimitKey: FeatureLimitsKeys.export,
  },
  {
    type: 'internal',
    appSlug: 'import',
    appName: 'Import',
    featureLimitKey: FeatureLimitsKeys.import,
  },
  {
    type: 'internal',
    appSlug: 'sharedspace',
    appName: 'Shared components',
    featureLimitKey: FeatureLimitsKeys.shared_components,
  },
  {
    type: 'internal',
    appSlug: 'activity',
    appName: 'Activities',
    featureLimitKey: FeatureLimitsKeys.ActivityLog,
  },
  {
    type: 'internal',
    appSlug: 'locales',
    appName: 'Dimensions',
    featureLimitKey: FeatureLimitsKeys.HasDimensionsApp,
  },
  {
    type: 'internal',
    appSlug: 'branches',
    appName: 'Pipelines',
    featureLimitKey: FeatureLimitsKeys.Pipelines,
  },
  {
    type: 'internal',
    appSlug: 'releases_only',
    appName: 'Releases',
    featureLimitKey: FeatureLimitsKeys.Releases,
  },
  {
    type: 'internal',
    appSlug: 'replace_asset',
    appName: 'Replace Asset',
    featureLimitKey: FeatureLimitsKeys.ReplaceAsset,
  },
  {
    type: 'internal',
    appSlug: 'translatable-slugs',
    appName: 'Translatable slugs',
    featureLimitKey: FeatureLimitsKeys.TranslatableSlugs,
  },
  {
    type: 'internal',
    appSlug: 'approval',
    appName: 'Approval',
    featureLimitKey: FeatureLimitsKeys.approval,
  },
  {
    type: 'internal',
    appSlug: 'cloudinary-native',
    appName: 'Cloudinary',
    featureLimitKey: FeatureLimitsKeys.cloudinary,
  },
  {
    type: 'internal',
    appSlug: 'backups',
    appName: 'S3 Backups',
    featureLimitKey: FeatureLimitsKeys.S3BackupFrequency,
  },
]

export const getInternalAppBySlug = (
  appSlug: string,
): InternalApp | undefined => {
  return INTERNAL_APPS.find((internalApp) => internalApp.appSlug === appSlug)
}
